export default class Part {
    static render(width) {
        const WIDTH = width * SIZE.pxInMm;
        const HEIGHT = SIZE.baseHeight // TODO  
        let x = (WIDTH - 122.74562) / 2
        let y = (HEIGHT - 122.63364) / 2;

        return `<image href="${PARTS['socket']}" x="${x}" y="${y}" />`
    }
}
